// eslint-disable-next-line no-restricted-imports
import * as uuid from 'uuid';

/**
 * Generate a UUID v4
 */
export function v4(): string {
  return uuid.v4();
}
